import React from "react"

interface Props {
  title: string
}

const Title: React.FC<Props> = ({ title }) => {
  return (
    <div>
      <h1 className="title nso-title has-text-primary is-size-1">{title}</h1>
    </div>
  )
}

export default Title
